import React from 'react';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import styles from './styled-select.module.scss';
import styleJs from './style';

const StyledSelect = ({
  name,
  control,
  rules,
  widthLabel = null,
  inline = false,
  placeholder = '',
  label = null,
  isCreatable = false,
  isClearable = false,
  ...props
}) => (
    <Controller
      name={name}
      control={control}
      rules={rules}
      onFocus={() => {
        console.log('controller focus');
      }}
      render={({
        field,
      }) => (
          <div className={inline ? `${styles['container-select']} ${styles.inline}` : `${styles['container-select']}`}>
            { label && <label style={widthLabel ? { minWidth: widthLabel } : {}}>{label}</label>}
            {!isCreatable
              ? <>
                <Select
                  {...field}
                  {...props}
                  className={`${styles.select} ${name === 'document_name' || name === 'product_name' ? styles.border : ''}`}
                  isClearable={isClearable}
                  placeholder={placeholder}
                  styles={styleJs}
                />
              </>
              : <>
                <CreatableSelect
                  {...field}
                  {...props}
                  className={`${styles.select}`}
                  placeholder={placeholder}
                  styles={styleJs}
                />
              </>
            }
          </div>
      )}
    />
);

StyledSelect.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  rules: PropTypes.object,
  widthLabel: PropTypes.string,
  inline: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
};

export default StyledSelect;
